import { useState, useEffect } from "react";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import styles from "./customToast.module.css";

export const CustomToast = ({ msg, err = false }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  return (
    <div className={styles.toastContainer}>
      <Row>
        <Col xs={6}>
          <ToastContainer position="top-end" className="p-3">
            <Toast
              show={show}
              onClose={() => setShow(false)}
              delay={3000}
              autohide
            >
              <Toast.Header>
                <strong className="me-auto">SupplyCorner - System</strong>
                <small className={err ? "text-danger" : "text-warning"}>
                  {err ? "Error" : "Success"}
                </small>
              </Toast.Header>
              <Toast.Body>{msg}</Toast.Body>
            </Toast>
          </ToastContainer>
        </Col>
      </Row>
    </div>
  );
};
